ixModuleRouting(
    "impactx.userctu",
    {
        "/userctulist": {
            template:"<ixa-user-ctu-list></ixa-user-ctu-list>",
            templateUrl: "modules/userctu/templates/userctulist.html",
            process: "ListUserCTU",
            controller: "UserCTUListController",
            controllerAs: "userCTUListController",
            workspace: "admin",
        },
    },
    ["ngRoute", "impactx.list"]
);
